import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "antd";
import { useForm } from "antd/lib/form/Form";
import { toast } from "react-hot-toast";
import { addNewProperty } from "./NewPropertyFirebase";
import PageHeading from "../../../components/common/PageHeading";
import FormAction from "../../../components/common/FormAction";
import PropertyNameAndAddress from "./componentss/PropertyNameAndAddress";
import PhotosUpload from "../../../components/common/PhotosUpload";
import AttachmentsUpload from "../../../components/common/AttachmentsUpload";
import Notes from "../../../components/common/Notes";
import PropertyInformation from "./componentss/PropertyInformation";
import RentalInformation from "./componentss/RentalInformation";
import NonRevenueStatus from "./componentss/NonRevenueStatus";
import Amenities from "./componentss/Amenities";
import LeaseSettings from "./componentss/LeaseSettings";
import ManagementFees from "./componentss/ManagementFees";
import LateFeePolicy from "./componentss/LateFeePolicy";
import MaintenanceInformation from "./componentss/MaintenanceInformation";
import OwnersAndFinancials from "./componentss/OwnersAndFinancials";
import AdditionalFees from "./componentss/AdditionalFees";
import PropertyGroups from "./componentss/PropertyGroups";
import BankAccounts from "./componentss/BankAccounts";
import { useNavigate } from "react-router";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../firebase";
import { collection, getDocs, query, where } from "@firebase/firestore";
import { v4 as uuidv4 } from "uuid";

function NewProperty() {
  const navigate = useNavigate();
  const [propertyType, setPropertyType] = useState("");
  const [isWait, setIsWait] = useState(false);
  const [financials, setFinancials] = useState([
    { id: uuidv4(), ownerId: "", percentOwned: "", contractExpires: "" },
  ]);
  const [terms, setTerms] = useState([
    { id: uuidv4(), term: "", changeByAmount: "0.00", additionalFee: "0.00" },
  ]);
  const [renwalFees, setRenewalFees] = useState([
    { id: uuidv4(), glAccount: "", percentage: "", suppress: false },
  ]);
  const [proptGroups, setProptGroups] = useState([
    { id: uuidv4(), propertyGroupId: "" },
  ]);
  const [accounts, setAccounts] = useState([
    { id: 1, cashGLAccount: "23291: Rental Income Account", bankAccount: "" },
    {
      id: 2,
      cashGLAccount: "23292: Security Deposit Bank Account",
      bankAccount: "",
    },
  ]);

  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
          setIsCompanyNameFetched(true);
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);
  const [dLT, setDLT] = useState([{ id: uuidv4(), template: "" }]);
  const [dRT, setDRT] = useState([{ id: uuidv4(), template: "" }]);
  const [dMRT, setDMRT] = useState([{ id: uuidv4(), template: "" }]);
  const [form] = useForm();

  const [notes, setNotes] = useState([]);
  const [files, setFiles] = useState([]);

  const handleFormSubmit = () => {
    setIsWait(true);
    form
      .validateFields()
      .then(() => {
        // Handle form submission with valid values
        const formData = form.getFieldsValue();

        Object.keys(formData).forEach((field) => {
          if (formData[field] === undefined) {
            formData[field] = "";
          }
        });

        const filteredFinancials = financials.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredTerms = terms.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredRenewalFees = renwalFees.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredPropGroups = proptGroups.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredMRT = dMRT.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredRT = dRT.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredLT = dLT.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredAccounts = accounts.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        const filteredNotes = notes.filter((item) => {
          return Object.keys(item).some(
            (key) => key !== "id" && item[key] !== ""
          );
        });

        console.log("owners data", filteredFinancials);

        addNewProperty(
          formData,
          filteredFinancials,
          filteredTerms,
          filteredRenewalFees,
          filteredPropGroups,
          filteredAccounts,
          filteredMRT,
          filteredRT,
          filteredLT,
          filteredNotes,
          companyName,
          files,
          navigate
        );
        console.log("success", proptGroups);
      })
      .catch((errorInfo) => {
        // Handle form submission with validation errors
        console.log("Validation Errors:", errorInfo.errorFields);
        setIsWait(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    setIsWait(false);

    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };
  const initialValues = {
    leaseGenerationMethod: "AppFolio Lease Templates",
    baseLateFeeFlat: "0.00",
    baseLateFeePercent: "0.00",
    managementFlatFee: "0.00",
    amount: "0.00",
    minimumFee: "0.00",
    maximumFee: "0.00",
  };
  return (
    <div className="page-container">
      <div className="main-container">
        <PageHeading heading="New Property" />
        <Form
          name="basic"
          labelCol={{ span: 7 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          className="form-container"
          colon={false}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <Card title="Property Name and Address">
                <PropertyNameAndAddress setPropertyType={setPropertyType} />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Property Information">
                <PropertyInformation propertyType={propertyType} />
              </Card>
            </Col>
            {propertyType === "Single Family" ? (
              <Col span={24}>
                <Card title="Non-Revenue Status">
                  <NonRevenueStatus propertyType={propertyType} />
                </Card>
              </Col>
            ) : null}
            <Col span={24}>
              <Card title="Rental Information">
                <RentalInformation propertyType={propertyType} />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Amenities">
                <Amenities />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Lease Settings">
                <LeaseSettings
                  initialValues={initialValues}
                  terms={terms}
                  setTerms={setTerms}
                  dLT={dLT}
                  sDLT={setDLT}
                  dRT={dRT}
                  sDRT={setDRT}
                  dMRT={dMRT}
                  sDMRT={setDMRT}
                />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Owners And Financials">
                <OwnersAndFinancials
                  financials={financials}
                  setFinancials={setFinancials}
                  companyName={companyName}
                  isCompanyNameFetched={isCompanyNameFetched}
                />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Management Fees">
                <ManagementFees initialValues={initialValues} />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Additional Fees">
                <AdditionalFees
                  renwalFees={renwalFees}
                  setRenewalFees={setRenewalFees}
                />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Late Fee Policy Details">
                <LateFeePolicy initialValues={initialValues} />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Maitenance Information">
                <MaintenanceInformation />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="PropertyGroups">
                <PropertyGroups
                  propertyGroups={proptGroups}
                  setPropertyGroups={setProptGroups}
                />
              </Card>
            </Col>
            <Col span={24}>
              <Card title="Bank Accounts">
                <BankAccounts accounts={accounts} setAccounts={setAccounts} />
              </Card>
            </Col>
            {/* <Col span={24}>
              <PhotosUpload />
            </Col> */}
            <Col span={24}>
              {companyName ? (
                <Notes
                  notesForCollection="properties"
                  notesForCollectionId=""
                  companyName={companyName}
                  notes={notes}
                  setNotes={setNotes}
                />
              ) : null}
            </Col>
            <Col span={24}>
              <AttachmentsUpload setFiles={setFiles} />
            </Col>
            <Col span={24}>
              <Row gutter={16}>
                <Col>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={isWait}
                  >
                    {isWait ? "wait...":"Save"}
                  </Button>
                </Col>
                <Col>
                  <Button>Cancel</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
        <br />
        <Row gutter={[0, 24]}></Row>
      </div>
    </div>
  );
}

export default NewProperty;
